import DocumentTitle from "react-document-title";
import { useHistory } from "react-router";
import "./Payments.sass";
import React from "react";
import { DefaultButton } from "@fluentui/react";

const PaymentCancelOk = () => {
  const history = useHistory();

  return (
    <DocumentTitle title="IronIA - Pago correcto">
      <React.Fragment>
        <h3>Orden cancelada correctamente</h3>
        <p className="description">La orden ha sido cancelada exitosamente.</p>
        <button>Volver a mis órdenes en curso</button>
        <DefaultButton
          className="button tiny-primary-button"
          onClick={() => history.push("/portfolio/orders")}
        ></DefaultButton>
      </React.Fragment>
    </DocumentTitle>
  );
};

export default PaymentCancelOk;
